<template>
  <div>
    <ModuleHeader>Utilidad Venta Producto</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="2" cols="6">
                <v-menu
                  v-model="menuFechaInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input_date"
                      label="Fecha Inicial"
                      prepend-icon="mdi-calendar"
                      readonly
                      @input="getAperturas()"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date"
                    @input="
                      menuFechaInicial = false;
                      getAperturas();
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" cols="6">
                <v-menu
                  v-model="menuFechaInicial2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input_date_final"
                      label="Fecha Final"
                      prepend-icon="mdi-calendar"
                      @input="getAperturas()"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date_final"
                    @input="
                      menuFechaInicial2 = false;
                      getAperturas();
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" cols="6">
                <v-autocomplete
                  label="Departamentos"
                  v-model="selectDep"
                  item-text="Nombre"
                  item-value="id"
                  @input="getAperturas()"
                  :items="departamentos"
                ></v-autocomplete>
              </v-col>

              <v-col md="2">
                <v-switch label="Mostrar folios" v-model="showFolios">
                </v-switch>
              </v-col>
              <v-col md="2">
                <v-switch label="Ordenar por categoria" v-model="orderCate">
                </v-switch>
              </v-col>
              <v-col md="6" cols="12">
                <v-autocomplete
                  v-model="input_familias"
                  label="Familias"
                  :items="familiasList"
                  item-value="id"
                  item-text="Nombre"
                >
                </v-autocomplete>
              </v-col>
              <v-col md="6" cols="12">
                <v-autocomplete
                  v-model="input_categoria"
                  label="Categoría del producto"
                  :items="categoriesList"
                  multiple
                  item-value="id"
                  item-text="label"
                >
                </v-autocomplete>
              </v-col>
              <v-col md="12" cols="12" class="mt-n6">
                <v-autocomplete
                  label="Turno"
                  v-model="selectTurno"
                  item-value="Turno"
                  item-text="Desc"
                  :items="turnosList"
                >
                </v-autocomplete>
              </v-col>
              <v-col md="12" cols="12" class="mt-n6">
                <v-autocomplete
                  label="Centro de consumo"
                  v-model="selectAlmacen"
                  item-value="id"
                  item-text="Nombre"
                  :items="origenes"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="text-right mt-n5" md="12" cols="12">
                <v-btn
                  depressed
                  @click="cleanFilter()"
                  class="mx-2"
                  color="error"
                >
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="6" cols="12">
                Resultados (La columna precio puede ser variable dependiento de
                modificadores y descuentos)
              </v-col>
              <v-col md="4" cols="6" class="text-right">
                <v-btn @click="generatePdf()" color="red" dark
                  ><v-icon>mdi-file-pdf-box</v-icon>
                  Agrupado por Categoria
                </v-btn>
              </v-col>
              <v-col md="2" cols="6" class="text-right">
                <v-btn color="green" dark @click="exportExcel"
                  ><v-icon>mdi-file-excel-box</v-icon>
                  Exportar a Excel
                  <!-- <download-excel
                    type="xls"
                    name="Venta producto"
                    :data="datos.processedData"
                  >
                  </download-excel> -->
                </v-btn>
              </v-col>
              <v-col md="12">
                <v-text-field v-model="filter" label="Filtrar"></v-text-field>
              </v-col>
            </v-row>
            <h3>Productos</h3>
            <v-simple-table v-if="render" dense>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Familia</th>
                  <th>Categoria</th>
                  <th>Vendidos</th>
                  <th>Precio (Variable)</th>
                  <th>Coste</th>
                  <th>Total Neto</th>
                  <th>Total Coste</th>
                  <th>Total Beneficio</th>
                  <th v-if="showFolios">Folios</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="datos.processedData.length == 0">
                  <td colspan="16">No se encontraron datos</td>
                </tr>
                <template v-for="(prod, index) in dataProductos">
                  <tr :key="index">
                    <td>
                      {{ prod.Id == "Reserva" ? "TEE TIMES" : prod.Nombre }}
                    </td>
                    <td>{{ prod.FamiliaName }}</td>
                    <td>{{ prod.CategoriaName }}</td>
                    <td>
                      <b>{{ prod.Vendidos }}</b>
                    </td>

                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Precio) }}</b>
                    </td>
                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Coste) }}</b>
                    </td>
                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Total) }}</b>
                    </td>
                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.TotalCoste) }}</b>
                    </td>
                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Beneficio) }}</b>
                    </td>
                    <td v-if="showFolios">
                      <b>{{ prod.Tickets }}</b>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>

<script>
import "../../assets/css/sideBar.css";
import Cliente from "../../clases/Cliente.js";
import moment from "moment";
import Currency from "../../clases/Currencies.js";
import Membresia from "../../clases/Membresias/Membresia.js";
import TarifasClass from "../../clases/Tarifa.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteVentaProducto from "../../clases/PdfMakers/ReporteUtilidadProducto.js";
import Vue from "vue";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ReporteGeneral",
  components: {
    /*Select2,*/
  },
  props: ["hideMenu"],
  data() {
    return {
      selectAlmacen: null,
      selectTurno: "ALL",
      selectDep: "ALL",
      Horarios: [],
      tarifas: [],
      orderCate: false,
      currencyClass: Currency,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      input_familias: "ALL",
      loadingData: false,
      render: true,
      showFolios: false,
      filter: "",
      datos: {
        all: [],
        processedData: [],
      },
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      selectedRes: "",
      data_clientes: [],
      tiposJuego: [],
      input_categoria: ["ALL"],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      tarifarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      Categories: [],
      familias: [],
      header: [
        "Cliente",
        "Membresia",
        "Folio",
        "Familia",
        "Categoría",
        "Descripción",
        "Cantidad",
        "Total",
        "Método de pago",
        "Autorización",
        "Total",
        "Impuestos",
      ],
      processedData: [],
      aperturas: [],
    };
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    origenes() {
      let ori = [
        
      ];
      let origenes = this.$store.getters.getCentrosConsumo;
      origenes.forEach((orig) => {
        ori.push(orig);
      });
      return ori;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    dataProductos() {
      if (this.filter != "") {
        return this.datos.processedData.filter((acc) =>
          acc.Nombre.toUpperCase().includes(this.filter.toUpperCase())
        );
      }
      return this.datos.processedData;
    },
    categoriesList() {
      let categories = [{ id: "ALL", label: "TODOS" }];

      this.Categories.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    familiasList() {
      let categories = [
        { id: "ALL", Nombre: "TODOS" },
        {
          id: "TRANSPORTACION",
          Nombre: "TRANSPORTACION (Sistema)",
        },
        {
          id: "EXTRA RIDER",
          Nombre: "EXTRA RIDER (Sistema) ",
        },
        {
          id: "Paquetes Rondas de Golf",
          Nombre: "Paquetes Rondas de Golf (Sistema)",
        },
      ];

      this.familias.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    Membresias() {
      return this.$pgsHelper.indexBy(Membresia.getMembresiasList(), "Id");
    },
    selectedReserva() {
      return this.selectedRes;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    comp_totales() {
      let total = {
        Cantidad: 0,
        Descuento: 0,
        Monto: 0,
        Subtotal: 0,
        Impuestos: 0,
      };
      this.datos.processedData.forEach((prod) => {
        total.Cantidad += Number(prod.Cantidad);
        let totalMonto = Number(prod.Subtotal) + Number(prod.Impuestos);
        total.Monto += Number(totalMonto);
        total.Descuento += Number(prod.Descuento);
        total.Subtotal += Number(prod.Subtotal);
        total.Impuestos += Number(prod.Impuestos);
      });
      return total;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  methods: {
    exportExcel() {
     GenericExcelExporter.generateExcelBuffer(this.datos.processedData)
       .then(buffer => {
         const blob = new Blob([buffer], {
           type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         });
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;
         link.download = "Venta producto.xlsx";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
         window.URL.revokeObjectURL(url);
       })
       .catch(error => console.error("Error exportando:", error));
   },
    cajasList() {
      let dep = [
        {
          id: "ALL",
          Nomb: "Todos",
        },
      ];
      this.data_cajas.forEach((de) => {
        if (de.Dpto == this.selectDep) {
          dep.push(de);
        }
      });
      return dep;
    },
    async getAperturas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //console.log(cierres);
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cashiers,
          "Id",
          apt.Cajero
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || " +
          cajeroData.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
     
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date,
        FF: this.input_date_final,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.dataProductos,
      };
      let docData = ReporteVentaProducto.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/Golf/Modalidades"
      );
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
      });
      
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      const cats = this.getCategoriesFiltered(claims);
      this.Categories = [{ id: "GREENFEE", label: "GREEN FEE" }, ...cats];
    },
    processVentas() {
      console.time("ProcessVentas");
      let origenes = this.$store.getters.getOrigenes;
      let origenSeleccionado = this.$pgsHelper.getById(
        origenes,
        "Origen",
        this.selectAlmacen
      );
      let productosVenta = [];
      let productosModificadores = {};
      let productosSum = {};
      let ProductosTickets = [];
      this.datos.all.forEach((el) => {
        let pagos = Object.entries(el.Pagos);
        const map = new Map();
        let client = this.$pgsHelper.searchIndex(
          this.comp_clients,
          "Id",
          el.Cliente.Id
        );
        let idMembresia = client.ExtraData?.Membresia?.Membresia;
        let Membresia = this.$pgsHelper.searchIndex(
          this.Membresias,
          "Id",
          idMembresia
        );
        el.Catalogo.forEach((prod) => {
          try {
            let precio = 0;
            prod.Identificador = prod.Id;
            if (prod.Pagos) {
              Object.entries(prod.Pagos).forEach((pago) => {
                precio += pago[1].def.C;
              });
            }
            let cantidad = prod.Cnt - (prod.Dto ? prod.Dto : 0);
            let indetPrice = precio > 0 ? precio / cantidad : 0;
            if (cantidad > 0) {
              prod.Id = prod.Id + "-" + indetPrice;

              if (prod.Id.includes("Reserva")) {
                prod.Nombre = "GREEN FEE";

                prod.OriginalId = prod.Id;
                prod.Categoria.N = "GREEN FEE";
                prod.Categoria.N = "GREEN FEE";
                let Catalogo = prod.Catalogo[0];
                let ExtraParams = Catalogo ? Catalogo.ExtraParams : false;
                let tarifaData = ExtraParams.TarifaData;
                //
                if (Catalogo.Tip == "Serie") {
                  prod.Nombre = prod.Nombre + " PREPAGADO " + Catalogo.Nombre;
                }


                if (tarifaData) {
                  let tarifarioId = tarifaData.Tar;
                  let Mod = tarifaData.Mod;
                  let Hor = tarifaData.Hor;
                  let SubNom = tarifaData.SubN;
                  let tipoJuego = this.$pgsHelper.getById(
                    this.tiposJuego,
                    "id",
                    Mod
                  );
                  let horario = this.$pgsHelper.getById(
                    this.Horarios,
                    "id",
                    Hor
                  );
                  let tarifa = this.$pgsHelper.getById(
                    this.tarifarios,
                    "Id",
                    tarifarioId
                  );

                  if (tarifaData.Tur) {
                    prod.Tur = tarifaData.Tur;
                  }

                  if (tarifa) {
                    prod.Nombre = prod.Nombre + " " + tarifa.text;
                  }
                  if (SubNom) {
                    prod.Nombre = prod.Nombre + " " + SubNom;
                  }
                  if (horario) {
                    prod.Nombre = prod.Nombre + " " + horario.NombreCompleto;
                  }
                  if (tipoJuego) {
                    prod.Nombre = prod.Nombre + " " + tipoJuego.nombre;
                  }
                }
                prod.Id =
                  prod.Id + "-" + prod.Categoria.I + "-" + tarifaData.Tar;
              }

              if (prod.Id.includes("RVA-ExtraRidder")) {
                prod.Nombre = "Extra rider";
                prod.Categoria.N = "EXTRA RIDER";
                prod.Categoria.I = "EXTRA RIDER";
                prod.Familia.N = "EXTRA RIDER";
                prod.Familia.I = "EXTRA RIDER";
              }

              if (prod.Id.includes("RVA-Transportacion")) {
                prod.Nombre = "Transportacion";
                prod.Categoria.N = "TRANSPORTACION";
                prod.Categoria.I = "TRANSPORTACION";
                prod.Familia.N = "TRANSPORTACION";
                prod.Familia.I = "TRANSPORTACION";
              }

              if (prod.Tip == "Cupon") {
                prod.Categoria.N = "Paquetes Rondas de Golf";
                prod.Categoria.I = "Paquetes Rondas de Golf";
                prod.Familia.N = "Paquetes Rondas de Golf";
                prod.Familia.I = "Paquetes Rondas de Golf";
              }

              let cntpagos = Object.entries(prod.Pagos).reduce(
                (acum, curr) => acum + curr[1].cnt,
                0
              );

             

              if (!productosSum[prod.Id]) {
            
                
                let coste =
                  origenSeleccionado?.Productos[prod.Identificador]?.PCP || 0;
                //if (origenSeleccionado?.Productos[prod.Identificador]) {
                  productosSum[prod.Id] = {
                    Categoria: prod.Categoria.I,
                    CategoriaName: prod.Categoria.N,
                    //InventarioData:origenSeleccionado?.Productos[prod.Identificador] || null,

                    Familia: prod.Familia.I,
                    FamiliaName: prod.Familia.N,
                    Nombre: prod.Nombre,
                    Tickets: [el.Folio],
                    Vendidos: cantidad,
                    Precio: precio > 0 ? precio / cantidad : 0,
                    Coste: coste,
                    Total: Number(precio),
                    TotalCoste: Number(coste * cantidad),
                    Beneficio: Number(precio) - Number(coste * cantidad),
                    Diff: cantidad - cntpagos,
                    Tur: prod.Tur,
                  };
                //}
              } else {
                let coste =
                  origenSeleccionado?.Productos[prod.Identificador]?.PCP || 0;
                productosSum[prod.Id].Vendidos =
                  productosSum[prod.Id].Vendidos + cantidad;
                productosSum[prod.Id].Total =
                  productosSum[prod.Id].Total + Number(precio);
                productosSum[prod.Id].TotalCoste =
                  productosSum[prod.Id].TotalCoste + Number(coste * cantidad);
                productosSum[prod.Id].Beneficio =
                  productosSum[prod.Id].Beneficio +
                  (Number(precio) - Number(coste * cantidad));
                productosSum[prod.Id].Diff += Number(
                  cantidad - Math.round(cntpagos)
                );
                productosSum[prod.Id].Tickets.push(el.Folio);
              }
            }
          } catch (e) {
            console.log(e);
          }
        });
      });
     
      let preData = Object.entries(productosSum);
      
      let arrayData = [];
      preData.forEach((data) => {
        if (this.input_familias != "ALL") {
          if (!this.input_categoria.includes("ALL")) {
            if (
              this.input_categoria.includes(data[1].Categoria) &&
              this.input_familias == data[1].Familia
            ) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
            if (
              this.input_categoria.includes("GREENFEE") &&
              data[0].includes("Reserva")
            ) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
          } else {
            if (this.input_familias == data[1].Familia) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
          }
        } else {
          if (!this.input_categoria.includes("ALL")) {
            if (this.input_categoria.includes(data[1].Categoria)) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
            if (
              this.input_categoria.includes("GREENFEE") &&
              data[0].includes("Reserva")
            ) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
          } else {
            arrayData.push({ Id: data[0], ...data[1] });
          }
        }
      });
      if (this.orderCate) {
        arrayData = this.$_.orderBy(
          arrayData,
          ["Categoria", "Vendidos"],
          ["desc", "desc"]
        );
      } else {
        arrayData = this.$_.orderBy(arrayData, "Vendidos", "desc");
      }

      this.datos.processedData = arrayData;
      console.timeEnd("ProcessVentas");
    },
    async getComboTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
    },
    async getTarifas() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];
      const data = await firestore.queryBuilder("RVA_Tarifas", filter);
      let tar = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      tar.forEach((tarifaData) => {
        let arrayPrecios = [];
        let arrayDays = Object.entries(tarifaData.Precios);
        arrayDays.forEach((mod) => {
          let modDias = mod[0].split("-");
          let textDias = "";
          modDias.forEach((element) => {
            textDias += " " + this.$pgsHelper.getDayName(element, "Simple");
          });
          let arrayModalidades = Object.entries(mod[1]);
          arrayModalidades.forEach((modalidad) => {
            let dataModalidades = {
              id: modalidad[0],
              textDias: textDias,
              dias: modDias,
              horarios: [],
            };
            let arrayHorarios = Object.entries(modalidad[1]);
            arrayHorarios.forEach((horario) => {
              let dataHorarios = {
                id: horario[0],
                ...horario[1],
              };
              dataModalidades.horarios.push(dataHorarios);
            });
            arrayPrecios.push(dataModalidades);
          });

          tarifaData.arrayPrecios = arrayPrecios;
        });
      });
      this.tarifas = tar;
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_folio = "";
      this.selectClient = "";
      this.selectDep = "ALL";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Cajas"
      );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Cajeros"
      );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/Golf/Horarios"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function(element) {
        $this.Horarios.push({
          id: element[0],
          NombreCompleto: element[1].Nombre,
          ...element[1],
        });
      });
    },
    async getVentas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("FechaVenta", ">=", startDate),
        firestore.where("FechaVenta", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];
      if (this.selectTurno != "ALL") {
        filter.push(firestore.where("Turno", "==", this.selectTurno));
      }
      if (this.selectDep != "ALL") {
        filter.push(firestore.where("Departamento", "==", this.selectDep));
      }

      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      const data = await firestore.queryBuilder("PDV_Ventas", filter);
      let preData = [];
      preData = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      preData.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
      });

      preData = this.$_.orderBy(preData, "fecha", "desc");

      this.datos.all = preData;
    },
    async getFamilias() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Productos/Familias"
      );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    searchVentas() {
      Promise.resolve()
        .then(() => {
          this.loadingData = true;
        })
        .then(() => {
          return this.getVentas();
        })
        .then(() => {
          this.loadingData = false;
        })
        .then(() => {
          return this.$nextTick();
        })
        .then(() => {
          this.processVentas();
        });
    },
  },
  watch: {
    origenes() {
      if(this.origenes[0]){
this.selectAlmacen = this.origenes[0].id || null
      }
      
    },
  },
  mounted() {
    
    //this.selectAlmacen = origenes[0].id || null
  },
  beforeCreate: function() {},
  beforeMount: function() {
    this.getTarifas();
    this.getCategories();
    this.getFamilias();
    this.getCajas();
    this.getCashiers();
    this.getTiposJuego();
    this.getHorarios();
    this.getComboTarifarios();
    this.getAperturas();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
